//#region src/v2/blocks/request-block/helpers/files.ts
/**
* Extract file name from an input
*/
var getFileName = (input) => {
	if (input instanceof File) return input.name;
};
//#endregion
export { getFileName };

//# sourceMappingURL=files.js.map